




























import { defineComponent, ref, watch } from "@vue/composition-api";
import { SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Announcement, AnnouncementTypeEnum } from "@scrile/api-provider/dist/api/AnnouncementsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import BaseIcon from "@/components/BaseIcon";
import AnnouncementsItem from "./components/AnnouncementsItem";

export default defineComponent({
  name: "Announcements",
  components: { BaseIcon, AnnouncementsItem, Swiper, SwiperSlide },
  setup() {
    const { isMember, isCreator } = useAuthUser();
    const loading = ref(false);
    const swiperRef = ref();
    const announcements = ref<Announcement[]>([]);
    const closed = ref(false);

    const swiperOptions: SwiperOptions = {
      slidesPerView: "auto",
      allowTouchMove: true,
      spaceBetween: 24,
      grabCursor: true,
      pagination: {
        el: ".announcements__slider-pagination",
        bulletElement: "div",
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active",
        dynamicBullets: true,
        clickable: true,
      },
      navigation: {
        prevEl: ".announcements__slider-prev",
        nextEl: ".announcements__slider-next",
      },
    };

    const onToggleClose = () => {
      closed.value = !closed.value;
    };

    const getAnnouncements = async () => {
      announcements.value = await providers.AnnouncementsProvider.search({
        data: {
          types: [
            AnnouncementTypeEnum.BOTH,
            isMember.value ? AnnouncementTypeEnum.MEMBER : AnnouncementTypeEnum.CREATOR,
          ],
          size: 999,
          sort: "SORT;ID,DESC",
        },
      });
    };

    const getData = async () => {
      try {
        loading.value = true;
        if (!isMember.value && !isCreator.value) return;
        await Promise.all([getAnnouncements()]);
      } finally {
        loading.value = false;
      }
    };

    watch(closed, async () => {
      if (!swiperRef.value) return;
      swiperRef.value.swiperInstance.allowTouchMove = !closed.value;
      swiperRef.value.updateSwiper();
    });

    getData();

    return {
      swiperRef,
      announcements,
      swiperOptions,
      loading,
      closed,
      onToggleClose,
    };
  },
});
